import React from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { Button, ButtonMode, CalendarIcon, TextField } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { isBefore } from 'date-fns';

import { createRules, FormFields } from '@epi-forms/helpers';
import { useModal } from '@epi-shared/hooks';
import { required as requiredValidation } from '@epi-helpers/formHelpers/validators';
import { IEntitledDataField } from '@epi-models/pages/Beneficiaries';
import { apiToDefaultDateFormat } from '@epi-helpers/dateHelper';

import { EntitledDataDialog } from '../EntitledDataDialog';

const name = FormFields.Entitled;

export const EntitledDataField = ({
  isRemoved = false,
  isAddMode = false
}: IEntitledDataField) => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { isModalOpen, openModal, closeModal } = useModal();
  const validators = [requiredValidation];
  const rules = createRules(validators);

  const {
    field: { value },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  const hasDatePassed = isBefore(new Date(value), new Date());

  return (
    <>
      <TextField
        id={name}
        label={t('download_reports.lunch_deduction.list.entitled')}
        value={apiToDefaultDateFormat(value)}
        readOnly
        required
        error={!!error}
        helperText={error?.message}
        InputProps={
          !isRemoved && (!hasDatePassed || isAddMode)
            ? {
                endAdornment: (
                  <Button
                    id="beneficiaries-detail-entitled-date-open-modal-button"
                    mode={ButtonMode.Link}
                    onClick={openModal}
                    type="button"
                  >
                    <CalendarIcon />
                  </Button>
                )
              }
            : undefined
        }
      />
      <EntitledDataDialog isOpen={isModalOpen} handleClose={closeModal} />
    </>
  );
};
